module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (locked) { ;
__p += '\n  <div class="locked-container stack-step">\n    <div class="help-block">\n      For security purposes, this account has been locked.\n      If this is your account, please\n      <a href="mailto:support@workstep.com">contact support</a>\n      for more information.\n    </div>\n  </div>\n';
 } else if (verify) { ;
__p += '\n  <div class="verify-container stack-step">\n    <div class="js-code-container"></div>\n  </div>\n';
 } else if (authorizationUrl) { ;
__p += '\n  <div class="stack-step">\n    <a href="' +
((__t = ( authorizationUrl )) == null ? '' : __t) +
'" class="btn btn-primary">Log in with SSO</a>\n  </div>\n';
 } else { ;
__p += '\n  <div class="password-container stack-step">\n    <div class="js-password-container">\n      <h1>Enter your password</h1>\n      <form class="auth-form">\n        <div class="input-button-group">\n          <input id="password" type="password" />\n          <button id="btn-login" class="btn btn-large btn-primary">Log In</button>\n        </div>\n        <div class="help-block js-error"></div>\n        <div class="help-block js-invalid" style="display: none">\n            Sorry! That password didn\'t work.<br />\n            <a href="#" class="js-forgot">Forgot your password?</a>\n        </div>\n      </form>\n      <div class="auth-login__or">\n        <hr />\n        <span>or</span>\n        <hr />\n      </div>\n    </div>\n    <div class="js-code-container auth__code-container"></div>\n  </div>\n';
 } ;
__p += '\n';

}
return __p
}